import classNames from "classnames";
import React, { CSSProperties } from "react";
import { styles } from "./grid.scss";


export function Grid({ columns, fit, spacing, wrapText, className, style, children }: Grid.Props)
{
    fit =
        (fit === true)
            ? "both"
            : fit ?? "none";
    spacing = spacing ?? "1em";

    const gridTemplateColumns =
        Array.isArray(columns) ?
            Grid.Column.getGridTemplate(columns) :
            `repeat(${columns}, auto)`;

    const gap =
        (typeof spacing == "number")
            ? `${spacing}em`
            : spacing;

    wrapText = wrapText ?? false;

    style = { gridTemplateColumns, gap, ...style };

    return (
        <div
            className={
                classNames(
                    styles.grid,
                    (!wrapText) && styles.nowrap,
                    (fit != "none") && styles[`fit-${fit}`],
                    className
                )
            }
            style={style}
        >
            {children}
        </div>
    );
};

export namespace Grid
{
    export interface Props
    {
        columns: number | Column.Width[];
        fit?: true | "none" | "width" | "height" | "both";
        spacing?: number | string;
        wrapText?: boolean;
        className?: classNames.Argument;
        style?: CSSProperties;
        children: React.ReactNode;
    }

    export namespace Column
    {
        export enum ResponsiveWidth
        {
            Expand = "expand",
            Fit = "fit",
        }

        export type Width = ResponsiveWidth | number;

        export function getGridTemplate(columns: Width[]): string
        {
            return (
                columns.map(
                    column =>
                    (
                        column == ResponsiveWidth.Expand && "auto" ||
                        column == ResponsiveWidth.Fit && "fit-content(0)" ||
                        `${column}fr`
                    )
                ).join(' ')
            );
        }
    }

    export type Unit = "fr" | "px" | "em" | "%";
}


export const Expand = Grid.Column.ResponsiveWidth.Expand;
export const Fit = Grid.Column.ResponsiveWidth.Fit;
